export const allTeams = state => state.teams.all
export const sessions = state => state.teams.sessions
export const activeTeam = state => state.teams.active



// WEBPACK FOOTER //
// ./src/vuex/teams/getters.js